import EventCalendar from "./EventCalendar";

export default EventCalendar;
